import { IFluidCodeDetails, isFluidPackage } from '@fluidframework/core-interfaces';

/**
 *  Simple utility for extracting the package name from fluid code details
 * TODO: This logic is used in multiple places and would be a great method to export from the fluidframework repo alongside isFluidPackage for reusability.
 */
export function getPackageName(codeDetails: IFluidCodeDetails): string | undefined {
  if (typeof codeDetails.package === 'string' || !isFluidPackage(codeDetails.package)) {
    return undefined;
  }

  return codeDetails.package.name;
}
